import React from 'react';
import classNames from 'classnames';

import './ai-report.scss';

interface AIReportProps {
    className?: string;
}

const AIReport: React.FC<AIReportProps> = ({ className }) => {
    return (
        <p className={classNames('ai-report', className)}>
            Treści powstały przy wsparciu narzędzia sztucznej inteligencji
        </p>
    );
};

export default AIReport;
